var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamation = function SvgExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0zm0 2a7 7 0 1 0 0 14A7 7 0 0 0 9 2zm0 10a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-7c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1s-1-.4-1-1V6c0-.6.4-1 1-1z",
    fill: "currentColor"
  })));
};
export default SvgExclamation;